const label = {};
label.Consignor = 'Consignor';
label.AddNewConsignor = 'Add New Consignor';
label.ConsignorID = 'Consignor ID';
label.Group = 'Group';
label.None = 'None';
label.Name = 'Name';
label.Active = 'Active';
label.Public = 'Public';
label.MAGS = 'MAGS';
label.Lookup = 'Lookup';
label.New = 'New';
label.SaveChanges = 'Save Changes';
label.Yes = 'Yes';
label.No = 'No';
label.Welcome = 'Welcome,';

const message = {};
message.ConsingorIDEmpty = 'Consignor id can not be empty';
message.SuccessfullyUpdated = 'Successfully updated information for consignor with id';
message.UnableToLocateConsignor = 'Unable to locate consignor with id';
message.ConsingorIDHasExisted = 'Cannot create new consignor because id has existed';

export { label, message };
